import _ from 'lodash';
import React from 'react';
import { toast } from 'react-toastify';
import autobind from 'autobind-decorator';
import { HFMModal } from 'client/shared/components';
import { observer, inject } from 'mobx-react';
import config from 'client/shared/config';
import AccountCreationForm from './account-creation-form';
import FIELD_KEY_MAP from './field-key-map';

const DFLT_MODAL_LABEL = 'Member Sign Up';
const DFLT_MODAL_BTN_LABEL = 'Sign Up With Email';
const DFLT_BTN_CLASS_NAME = 'button neo mdl';

const DFLT_MODAL_STYLE = {
	base: 'modal member-sign-up'
};

@inject('userStore')
@observer
class Saving extends React.Component {
	render () {
		const { userStore, savingMessage } = this.props;
		if (userStore.isLoading || _.isEmpty(savingMessage) !== true) {

			return (
				<div
					style={{
						position: 'absolute',
						top: 0,
						bottom: 0,
						left: 0,
						right: 0,
						background: '#282427',
						textAlign: 'center',
						zIndex: 1,
						paddingTop: '45%'
					}}
				>
					{ savingMessage }
				</div>
			);
		}

		return null;
	}
}

@inject('formStore')
@observer
class ProgressInfo extends React.Component {
	render () {
		const {
			formStore: {
				validation: {
					profileImage = false,
					accountCreationForm = false
				}
			}
		} = this.props;

		const cellClassName = 'cell small-3 padding-bottom-0 text-right';
		const highlightClass = 'highlight-text';
		const disabledClass = 'disabled-text';
		const imageProgressClassName = profileImage ? highlightClass : disabledClass;
		const infoProgressClassName = accountCreationForm ? highlightClass : disabledClass;

		return (
			<div className="grid-x grid-padding-x grid-padding-y artist-sign-up-progress">
				<div className={ `${ cellClassName } ${ imageProgressClassName }` }>
					<span className="fas fa-check"></span> Image
				</div>
				<div className={ `${ cellClassName } ${ infoProgressClassName }` }>
					<span className="fas fa-check"></span> Info
				</div>
			</div>
		);
	}
}

@inject('userStore', 'formStore')
@observer
class AddMemberModal extends React.Component {
	state = {
		bio: '',
		savingMessage: '',
		formIsValid: false
	}

	constructor (props) {
		super(props);

		const { formStore, userStore } = this.props;

		formStore.validation = {
			profileImage: false,
			accountCreationForm: false
		};

		this.user = userStore.newUser({
			...userStore.newFBUserData,
			role: userStore.roles.SUBSCRIBER
		});
	}

	componentDidMount () {
		document.addEventListener('keypress', this.onKeyPress);
	}

	componentWillUnmount () {
		document.removeEventListener('keypress', this.onKeyPress);
	}

	render () {
		const {
			userStore,
			formStore,
			iconClassName,
			modalContentLabel = DFLT_MODAL_LABEL,
			buttonLabel = DFLT_MODAL_BTN_LABEL,
			buttonClassName = DFLT_BTN_CLASS_NAME,
			modalClassName = DFLT_MODAL_STYLE,
			modalOverlayClassName = DFLT_OVERLAY_STYLE
		} = this.props;

		return (
			<div className="member-sign-up">
				<HFMModal
					isOpen={ userStore.addMemberModalOpen }
					contentLabel={ modalContentLabel }
					styles={ DFLT_MODAL_STYLE }
					style={{
						content: {
							maxWidth: '33vw',
							position: 'absolute',
							top: '10vh',
							bottom: '10vh',
							marginLeft: 'auto',
							marginRight: 'auto',
							textAlign: 'center'
						}
					  }}
				>
					{/* <h4 className="padding-left-2 padding-top-1">{ modalContentLabel }</h4> */}
					<div className="grid-x align-middle" style={{justifyContent:"center", paddingTop:'2vh', paddingBottom:'2vh'}}>
						<div className="admin-title">Fan Sign Up</div>
					</div>
					<ProgressInfo />
					<div className="artist-cms cell small-12 padding-bottom-0" style={{ backgroundColor: '#000', color: '#fff'}}>
						{ this.renderModalContent() }
					</div>
				</HFMModal>

				<button
					data-ta="addBandBtn"
					className={ buttonClassName }
					onClick={ this.handleOpenModal }
				>
					{
						_.isString(iconClassName) ? <span className={ iconClassName }></span> : null
					}
					{ buttonLabel }
				</button>
			</div>
		);
	}

	renderModalContent () {
		return (
			<div className="modal-content" data-ta="addMemberModal">
				<Saving savingMessage={ this.state.savingMessage } />
				<AccountCreationForm user={ this.user } />

				{ this.renderButtons() }
			</div>
		);
	}

	renderButtons () {
		return (
			<div className="modal-button-group">
				<button
					data-ta="closeAddMemberModalBtn"
					className="button neo mdl"
					onClick={ this.handleCloseModal }
				>
					Cancel
				</button>
				&nbsp;&nbsp;
				<button
					type="button hollow"
					data-ta="saveAddMemberModalBtn"
					className="button neo mdl"
					onClick={ this.onSubmitClick }
					disabled={ this.submitDisabled() }
				>
					Continue
				</button>
			</div>
		);
	}

	@autobind
	handleOpenModal () {
		this.props.userStore.addMemberModalOpen = true;
	}

	@autobind
	handleCloseModal () {
		this.props.userStore.addMemberModalOpen = false;
	}

	submitDisabled () {
		const {
			formStore: {
				validation: {
					// profileImage = false,
					accountCreationForm = false
				}
			}
		} = this.props;

		const submitDisabled =
			// profileImage !== true ||
			accountCreationForm !== true;

		return submitDisabled;
	}

	@autobind
	onKeyPress ({ key }) {
		const isEnterKey = (/enter/i).test(key);
		if (isEnterKey && this.submitDisabled() !== true) {

			this.onSubmitClick();
		}
	}

	@autobind
	async onSubmitClick () {
		const doesEmailExist = await this.doesEmailExist();
		if (doesEmailExist) {

			toast.error('That email address already exists.');
			return;
		}

		const isFormValid = this.isFormValid();
		if (isFormValid !== true) {

			toast.error('Please complete all required fields.');
			return;
		}
		
		await this.saveProfile();

		this.handleAutoLogin();
	}

	async doesEmailExist () {
		const { user: { email }, props: { userStore } } = this;
		const { exists } = await userStore.checkEmail(email);

		if (exists) {

			toast.error(`${email} already exists.`);
			return exists;
		}

		return false;
	}

	isFormValid (fields = _.values(FIELD_KEY_MAP)) {
		const { props: { formStore }, user } = this;

		const isFormValid = formStore.validateFields(fields, (key) => {
			const value = user[key.replace(/^.+\./, '')];

			if (key === FIELD_KEY_MAP.confirmPassword) {

				return {
					confirmPassword: value,
					password: user.password
				};
			}

			return value;
		});

		if (isFormValid !== true) {

			const message = 'Please enter all required fields';

			toast.error(message);
		}

		return isFormValid;
	}

	doPasswordsMatch () {
		const { user: { password, confirmPassword } } = this;
		const doPasswordsMatch = password === confirmPassword;

		if (doPasswordsMatch !== true) {

			toast.error('Please make sure your confimation password matches your password.');
		}

		return doPasswordsMatch;
	}

	async saveProfile () {
		this.setState({
			savingMessage: 'Saving profile...'
		});

		await this.user.save();
	}

	handleAutoLogin () {
		window.location.href = '/login';
		// this.setState({
		// 	savingMessage: 'Log in...'
		// });

		// this.props.userStore.checkLogin({
		// 	sendRedirect: true,
		// 	...this.user.serialized
		// });
	}
};


export default AddMemberModal;
